import React, { Component, Fragment } from 'react'

class Steps extends Component {
    renderSteps() {
        const { steps, css } = this.props

        return (
            <Fragment>
                {
                    steps.map((step, key) => {
                        return (
                            <div className={`row ${css}`} key={key} style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                paddingTop: 20,
                                paddingBottom: 20
                            }}>
                                <div className="col-lg-2" style={{ fontSize: '4em', fontWeight: 'bold', opacity: '.4' }}>{key + 1}</div>
                                <p key={key} dangerouslySetInnerHTML={{ __html: step }} className="text-left col-lg-10" style={{ color: '#ddd', paddingTop: 20 }}></p>
                            </div>
                        )
                    })
                }
            </Fragment>
        )
    }

    render() {
        return (
            <Fragment>
                {this.renderSteps()}
            </Fragment>
        )
    }
}

export { Steps }


// WEBPACK FOOTER //
// ./src/components/sections/Steps.js